module.exports = __webpack_public_path__ + "static/media/addoncart.80682729.svg";